import axios from 'axios';
import { apiUrl } from '@qwealth/qdata';

export const getDigitExportData = (householdQID: string) =>
  axios
    .get(`${apiUrl}/qfolio/modelExport/${householdQID}`)
    .then(response => console.log({ response }));
